import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class LogsDTO {
  @ApiProperty()
  @IsNotEmpty({message:"Log Id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  logId?: number;

  @ApiProperty()
  @IsNotEmpty({message:"Table Name should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  tableName: string;

  @ApiProperty()
  operationName: string;
  @ApiProperty()
  rowId:number;
  @ApiProperty()
  displayValue:string;

  @ApiProperty()
  previousValue?:string;

  @ApiProperty()
  presentValue?:string;

  @ApiProperty()
  status:boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
//   @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  @ApiProperty()
  versionFlag : number;
}

